export default function Footer() {
  return (
    <footer className="border-t border-gray-200 mt-16 py-5 px-6 text-[11px] font-mono text-gray-500 uppercase tracking-[0.12em] flex items-center justify-between">
      <span>AssureAI&nbsp;·&nbsp;Audit Utilities</span>
      <span>§43B(h) MSME Disallowance</span>
    </footer>
  );
}
